// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../BaseIcon";
import type { CurrencyIconProps } from "../types";

const coloredContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M8.5 3C8.5 4.933 10.067 6.5 12 6.5C13.933 6.5 15.5 4.933 15.5 3H19V21H15.5C15.5 19.067 13.933 17.5 12 17.5C10.067 17.5 8.5 19.067 8.5 21H5V3H8.5Z" fill="#FFB2BF"/></svg>`;
const monoContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M8.5 3C8.5 4.933 10.067 6.5 12 6.5C13.933 6.5 15.5 4.933 15.5 3H19V21H15.5C15.5 19.067 13.933 17.5 12 17.5C10.067 17.5 8.5 19.067 8.5 21H5V3H8.5Z" style="fill: currentColor"/></svg>`;

export const XsollaTicket: React.FC<CurrencyIconProps> = (props) => (
  <BaseIcon
    {...props}
    coloredContent={coloredContent}
    monoContent={monoContent}
  />
);
